import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { taskListAll } from "@/api/task";
export var gameTask = {
  namespaced: true,
  state: {
    isInit: 0,
    taskKv: {}
  },
  mutations: {
    setTaskKv: function setTaskKv(state, taskMap) {
      state.isInit = 1;
      state.taskKv = taskMap;
    }
  },
  actions: {
    getTask: function getTask(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, taskMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return taskListAll();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                taskMap = {};
                res.data.list.forEach(function (val) {
                  taskMap[val.task_id] = val.task_name;
                });
                commit("setTaskKv", taskMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  //派生状态
  getters: {
    taskMap: function taskMap(state) {
      return state.taskKv;
    }
  }
};